module.exports = __webpack_public_path__ + "img/fd4f60b.png";